const Config = {
    url : "https://customapps.pgc.ie",
    apiKey: "62c1e20672eb6a063e0ff08576b050f8",
    shop: "luli-fama.myshopify.com"
}

export default Config;
